function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
function withStripeElementsMethodsHOC(WrappedComponent) {
  return class withStripeElementsMethods extends React.Component {
    constructor(...args) {
      super(...args);
      _defineProperty(this, "state", {
        isResized: window.innerWidth > 1440,
        width: window.innerWidth,
        error: {
          type: 'validation_error',
          code: '',
          message: ''
        }
      });
      _defineProperty(this, "updateDimensions", () => {
        this.setState({
          width: window.innerWidth
        });
      });
      _defineProperty(this, "onChangeStripeField", name => event => {
        const {
          setStripeFieldError,
          setStripeFieldEmpty,
          setStripeFieldCompleted
        } = this.props;

        // @todo. auto generated. fix this error
        // @ts-ignore
        setStripeFieldError({
          [name]: event.error || null
        });
        // @todo. auto generated. fix this error
        // @ts-ignore
        setStripeFieldEmpty({
          [name]: event.empty
        });
        // @todo. auto generated. fix this error
        // @ts-ignore
        setStripeFieldCompleted({
          [name]: event.complete
        });

        // @todo. auto generated. fix this error
        // @ts-ignore
        this.setState({
          error: event.error
        });
      });
    }
    shouldComponentUpdate(nextProps, nextState) {
      const {
        isResized,
        width,
        error
      } = this.state;
      if (!isResized && width > 1440) {
        this.setState({
          isResized: true
        });
        return true;
      }
      if (isResized && width < 1440) {
        this.setState({
          isResized: false
        });
        return true;
      }
      if (!error && nextState.error || error && !nextState.error) {
        return true;
      }
      return false;
    }
    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
    render() {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        onChangeStripeField: this.onChangeStripeField
      }, this.props));
    }
  };
}
export default withStripeElementsMethodsHOC;